<template>
  <div v-in-viewport.once class="transition">
    <router-link :to="link" :target="target" class="button" :class="css" v-if="!target">
      <div class="button__arrow">
        <svg enable-background="new 0 0 24 24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m8.6 16.6 4.6-4.6-4.6-4.6 1.4-1.4 6 6-6 6z" /></svg>
      </div>
      <slot></slot>
    </router-link>
    <a :href="link" :target="target" class="button" :class="css" v-if="target">
      <div class="button__arrow">
        <svg enable-background="new 0 0 24 24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m8.6 16.6 4.6-4.6-4.6-4.6 1.4-1.4 6 6-6 6z" /></svg>
      </div>
      <slot></slot>
    </a>  
  </div>
</template>

<style lang="scss">
.button{
  position: relative;
  display: block;
  width: 360px;
  height: 80px;
  border: 1px solid rgba($black,0.2);
  border-radius: 40px;
  background-color: white;
  color: $black;
  text-decoration: none;
  padding: 20px;
  padding-left: 80px;
  margin-top: 5rem;
  font-weight: bold;
  @include TIMES;
  transition: all .5s ease;
  z-index: 1;

  @media #{$bp-sm}{
    font-size: 1.6rem;
    line-height: 2.1rem;
    width: auto;
    padding-right: 3rem;
    margin-top: 3rem;
    // margin-bottom: 3rem;
  }

  &__arrow{
    position: absolute;
    background-color: black;
    border-radius: 100%;
    width: 44px;
    height: 44px;
    left: 18px;
    top: 18px;
    transition: all .5s ease;
  }

  svg{
    position: absolute;
    top: 10px;
    left: 10px;
    width: 24px;
    height: 24px;
    path{
      transition: all .5s ease;
      fill: white;
    }
  }

  &:hover{
    background-color: black;
    color: white;
    
    .button__arrow{
      background-color: white;
      // transform: scale(0.8);
    }

    svg{
      path{
        fill: black;
      }
    }
  }

  &--3lines{
    height: 105px;
    border-radius: 57px;
    padding-left: 100px;
    .button__arrow{
      left: 30px;
      top: 30px;
    }
    @media #{$bp-sm-up}{

    }
  }
  &--3lines2{
    padding-top: 30px;
  }

  &--blue{
    border: 1px solid rgba($blue, 0.2);
    .button__arrow{
      background-color: $blue;
    }


    &:hover{
      background-color: $blue;
      color: white;
      
      .button__arrow{
        background-color: white;
        // transform: scale(0.8);
      }

      svg{
        path{
          fill: $blue;
        }
      }
    }
  }
  &--transp-white{
    color: white;
    background-color: transparent;
    border-color: rgba(255,255,255,0.18);
    .button__arrow{
      background-color: white;
    }
    svg {
      path {
        fill: black;
      } 
    }
  }
  &--transp-blue{
    color: white;
    background-color: transparent;
    border-color: rgba(#607d8b,0.5);
    .button__arrow{
      background-color: white;
    }
    svg path{
      fill: black;
    }
  }

}
</style>

<script>
export default {
  props: ['link', 'text', 'target', 'css'],
  data() {
    return {
    };
  },
  methods: {
  },
};
</script>
